<template>
<div class="modal-mask-home background-rhythm">
    <div class="modal-wrapper-home-gallery">
        <div class="modal-container-home-gallery-rhythm">
            <div class="close-gallery tamanhoicon" @click="$emit('backToGallery')">
                <img :src="require('@/assets/buttons/newbuttons/rhythm/close.svg')" />
            </div>
            <div class="modal-header-home modal-header-home-sum tamanhotitle">
                <slot name="header">
                    <span> {{saved_game.title}} ({{saved_game.game_id}})</span>
                    <br/>
                    <span class="update-date" v-if="saved_game.last_updated"> LAST UPDATE: {{saved_game.last_updated}}</span>
                    <span class="update-date" v-else> CREATED AT: {{saved_game.created_at}}</span>
                </slot>
            </div>
            <div class="modal-body-home-gallery">
                <slot name="body">
                    <SummaryScore v-if="game_loaded" :phrases="game['game_info']['phrases']" :phrases_saved="game['game_info']['displayPhrases']" @backToMenu="$emit('backToMenu');" @restart="$emit('editScore', game['saved_options']);"/>
                </slot>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import SummaryScore from "@/components/RhythmGame/SummaryScore.vue";

export default {
    name: "RhythmSave",
    emits: ['backToMenu', 'backToGallery', 'editScore'],
    data() {
        return {
            game: {},
            game_loaded: false
        };
    },
    components: {
        SummaryScore,
    },
    props: {
        saved_game: Object,
    },
    mounted() {
        this.getGameInfo(this.saved_game);
    },
    methods: {
        getGameInfo(save) {
            fetch(process.env.VUE_APP_API_URL + "/getSavedGame?game_id=" + save.game_id, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "*",
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        Accept: "application/json, text/plain, *//**",
                    },
                    method: "GET",
                }).then((res) => {
                    return res.json();
                })
                .then((devs) => {
                    this.game = devs[0];

                    if ('game_info' in this.game) {
                        this.game_loaded = true;
                    }

                    console.log(this.game)
                })
                .catch((error) => {
                    console.log(error);
                    error = true;
                });
        },
    }
};
</script>

<style>
.modal-wrapper-home-gallery {
    display: table-cell;
    vertical-align: middle;
}

.modal-container-home-gallery-rhythm {
    width: 94%;
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0px auto;
    background-color: rgba(128, 190, 250, 0.9);
    padding: 1em;
    border-radius: 25px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Omnes, sans-serif;
    animation: movecontainerHome 1s ease-in-out;
}

@keyframes movecontainerHome {
    0% {
        margin-top: -100%;
    }

    100% {
        margin-top: 0;
    }
}

.modal-body-home-gallery {
    margin-top: -1.2em;
    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
    width: 65%;
    height: 100%;
    z-index: 9999;
}

.modal-header-home-sum {
    margin-top: 0em;
}

.close-gallery {
    position: absolute;
    right: 2.5%;
    z-index: 10000;
}

.update-date {
    font-size: 40%;
}
</style>
